import './ListProducts.scss'

import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DragDropContext, Droppable } from '@hello-pangea/dnd'

import { excludeAudioItems, reorderItemInArray } from 'hb4e-ui-context'

import ListItemDetails from './ListItemDetails/ListItemDetails'
import PurchasedListItemDetails from './PurchasedListItemDetails/PurchasedListItemDetails'
import SortableListItemDetails from './SortableListItemDetails/SortableListItemDetails'
import { setReorderableItems } from '../../../../../actions'
import { selectIsReordering, selectReorderableItems } from '../../../../../reducers'

const ListProducts = ({ list }) => {
  const dispatch = useDispatch()
  const isReordering = useSelector(selectIsReordering)
  const reorderableItems = useSelector(selectReorderableItems)

  let ListItemComponent
  let items
  let sortedItems

  if (isReordering) {
    const handleOnDragEnd = (result, provided) => {
      // Item was dropped outside the list
      if (!result.destination) {
        return
      }

      if (result?.reason === 'DROP') {
        const { draggableId: movedItemTitle, source, destination } = result
        const startPosition = source.index + 1
        const endPosition = destination.index + 1

        provided.announce(`You have moved ${movedItemTitle} in position ${startPosition} to position ${endPosition}`)
      }

      return dispatch(
        setReorderableItems(reorderItemInArray(reorderableItems, result.source.index, result.destination.index)),
      )
    }

    const handleOnDragUpdate = (update, provided) => {
      const { draggableId: movedItemTitle, source, destination } = update
      const startPosition = source.index + 1
      const endPosition = destination.index + 1

      return provided.announce(
        `You are moving ${movedItemTitle} in position ${startPosition} to position ${endPosition}`,
      )
    }

    return (
      <div className="list-products">
        <DragDropContext onDragEnd={handleOnDragEnd} onDragUpdate={handleOnDragUpdate}>
          <Droppable droppableId="list-products-droppable">
            {(provided) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                className="list-products__sortable-list-container"
              >
                {reorderableItems.map((item, index) => (
                  <SortableListItemDetails key={`item-${index}`} index={index} item={item} />
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    )
  }

  if (list.isPurchasedList()) {
    ListItemComponent = PurchasedListItemDetails
    items = list.getItems()
    sortedItems = items.sort((a, b) => new Date(b.latestPurchasedDate) - new Date(a.latestPurchasedDate))
  } else {
    ListItemComponent = ListItemDetails
    items = excludeAudioItems(list.getItems())
    sortedItems = items.sort((a, b) => a.sortOrder - b.sortOrder)
  }

  return (
    <section className="list-products">
      {sortedItems.map((item, index) => (
        <ListItemComponent key={index} item={item} list={list} />
      ))}
    </section>
  )
}

export default ListProducts
